// removed by extract-text-webpack-plugin
module.exports = {"title":"no-categories__title___2TvCv"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/manage-categories/no-categories.scss
// module id = 1342
// module chunks = 0